import { cn as e } from "../cn.js";
import { Button as t } from "../button/index.js";
import { Icon as n } from "../icon/index.js";
import { Alert as r } from "../alert/index.js";
import { backdropVariants as i, closeTriggerVariants as a, contentVariants as o, descriptionVariants as s, footerVariants as c, positionerVariants as l, titleVariants as u } from "./style.js";
import d from "react";
import { jsx as f, jsxs as p } from "react/jsx-runtime";
import { Portal as m } from "@ark-ui/react/portal";
import { When as h } from "react-if";
import { Dialog as g } from "@ark-ui/react/dialog";
// src/design/modal/index.tsx
var _ = ({ children: e, closeOnInteractOutside: t = !1, ...n }) => /* @__PURE__ */ f(g.Root, {
	closeOnInteractOutside: t,
	...n,
	children: e
}), v = ({ children: e, className: t, ...n }) => /* @__PURE__ */ f(g.Trigger, {
	...n,
	className: t,
	children: e
}), y = ({ children: t, className: n, ...r }) => /* @__PURE__ */ f(g.Backdrop, {
	...r,
	className: e(i(), n),
	children: t
}), b = ({ children: t, className: n, centered: r, scrollMode: i = "outside", ...a }) => /* @__PURE__ */ f(g.Positioner, {
	...a,
	className: e(l({
		centered: r,
		scrollMode: i
	}), n),
	children: t
}), x = ({ children: t, className: n, size: r, scrollMode: i = "outside", ...a }) => /* @__PURE__ */ f(g.Content, {
	...a,
	className: e(o({
		size: r,
		scrollMode: i
	}), n),
	children: t
}), S = ({ children: t, className: n, size: r, ...i }) => /* @__PURE__ */ f(g.Title, {
	...i,
	className: e(u({ size: r }), n),
	children: t
}), C = ({ children: t, className: n, size: r, ...i }) => /* @__PURE__ */ f(g.Description, {
	...i,
	className: e(s({ size: r }), n),
	children: t
}), w = ({ children: t, className: r, position: i, ...o }) => /* @__PURE__ */ f(g.CloseTrigger, {
	"aria-label": t ? void 0 : "Close",
	...o,
	className: e(a({ position: i }), r),
	children: t ?? /* @__PURE__ */ f(n, {
		name: "X",
		size: "sm"
	})
}), T = ({ children: t, className: n, align: r, ...i }) => /* @__PURE__ */ f("div", {
	...i,
	className: e(c({ align: r }), n),
	children: t
}), E = ({ children: t, className: n, ...r }) => /* @__PURE__ */ f("div", {
	...r,
	className: e(n),
	children: t
}), D = ({ trigger: e, title: t, description: n, closeTrigger: r, children: i, rootProps: a, size: o = "md", centered: s = !0, showCloseButton: c = !0, closeOnInteractOutside: l = !1, scrollMode: u = "outside" }) => {
	let d = o === "xl" || o === "2xl" || o === "3xl" || o === "4xl" || o === "5xl" || o === "6xl" || o === "full" ? "lg" : o;
	return /* @__PURE__ */ p(g.Root, {
		lazyMount: !0,
		unmountOnExit: !0,
		closeOnInteractOutside: l,
		...a,
		children: [/* @__PURE__ */ f(h, {
			condition: !!e,
			children: /* @__PURE__ */ f(g.Trigger, {
				asChild: !0,
				children: e
			})
		}), /* @__PURE__ */ p(m, { children: [/* @__PURE__ */ f(y, {}), /* @__PURE__ */ f(b, {
			centered: s,
			scrollMode: u,
			children: /* @__PURE__ */ p(x, {
				size: o,
				scrollMode: u,
				children: [
					/* @__PURE__ */ f(h, {
						condition: !!t,
						children: /* @__PURE__ */ f(S, {
							size: d,
							children: t
						})
					}),
					/* @__PURE__ */ f(h, {
						condition: !!n,
						children: /* @__PURE__ */ f(C, {
							size: d,
							children: n
						})
					}),
					i,
					/* @__PURE__ */ f(h, {
						condition: c,
						children: /* @__PURE__ */ f(w, { children: r })
					})
				]
			})
		})] })]
	});
}, O = "That did not work. Try again.", k = (e, t) => {
	let [n, r] = d.useState(!1), [i, a] = d.useState(null);
	return {
		isLoading: n,
		failure: i,
		clearFailure: () => a(null),
		run: async (n) => {
			a(null), r(!0);
			try {
				await e?.();
			} catch (e) {
				a(e instanceof Error && e.message ? e.message : O);
				return;
			} finally {
				r(!1);
			}
			t && n();
		}
	};
}, A = ({ trigger: e, title: i = "Confirm Action", description: a = "Are you sure you want to proceed with this action?", confirmLabel: o = "Confirm", cancelLabel: s = "Cancel", onConfirm: c, onCancel: l, rootProps: u, variant: d = "danger", icon: _, loading: v = !1, closeOnConfirm: w = !0, error: E }) => {
	let { isLoading: D, failure: O, clearFailure: A, run: j } = k(c, w), M = D || v, N = E ?? O, P = _ ?? (d === "danger" ? /* @__PURE__ */ f("div", {
		className: "mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-destructive/10",
		children: /* @__PURE__ */ f(n, {
			name: "AlertTriangle",
			className: "h-6 w-6 text-destructive"
		})
	}) : d === "warning" ? /* @__PURE__ */ f("div", {
		className: "mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-warning/10",
		children: /* @__PURE__ */ f(n, {
			name: "AlertCircle",
			className: "h-6 w-6 text-warning-text"
		})
	}) : /* @__PURE__ */ f("div", {
		className: "mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-info/10",
		children: /* @__PURE__ */ f(n, {
			name: "Info",
			className: "h-6 w-6 text-info-text"
		})
	})), F = d === "danger" ? "danger" : d === "warning" ? "warning" : "primary";
	return /* @__PURE__ */ p(g.Root, {
		lazyMount: !0,
		unmountOnExit: !0,
		closeOnInteractOutside: !1,
		...M ? { closeOnEscape: !1 } : null,
		...u,
		onOpenChange: (e) => {
			e.open || A(), u?.onOpenChange?.(e);
		},
		children: [/* @__PURE__ */ f(h, {
			condition: !!e,
			children: /* @__PURE__ */ f(g.Trigger, {
				asChild: !0,
				children: e
			})
		}), /* @__PURE__ */ p(m, { children: [/* @__PURE__ */ f(y, {}), /* @__PURE__ */ f(b, {
			centered: !0,
			children: /* @__PURE__ */ p(x, {
				size: "sm",
				children: [
					/* @__PURE__ */ p("div", {
						className: "text-center",
						children: [
							P,
							/* @__PURE__ */ f(S, {
								size: "md",
								className: "mt-4 text-center",
								children: i
							}),
							/* @__PURE__ */ f(C, {
								size: "md",
								className: "text-center",
								children: a
							})
						]
					}),
					N && /* @__PURE__ */ f("div", {
						className: "pt-3",
						children: /* @__PURE__ */ f(r, {
							config: {
								variant: "subtle",
								colorScheme: "danger"
							},
							description: N
						})
					}),
					/* @__PURE__ */ p(T, {
						align: "center",
						className: "mt-5 pt-0 border-0",
						children: [/* @__PURE__ */ f(g.CloseTrigger, {
							asChild: !0,
							children: /* @__PURE__ */ f(t, {
								variant: "secondary",
								size: "sm",
								onClick: l,
								disabled: M,
								children: s
							})
						}), /* @__PURE__ */ f(g.Context, { children: (e) => /* @__PURE__ */ f(t, {
							colorScheme: F,
							size: "sm",
							onClick: () => void j(() => e.setOpen(!1)),
							loading: M,
							disabled: M,
							children: o
						}) })]
					})
				]
			})
		})] })]
	});
}, j = ({ trigger: e, title: i = "Notification", description: a = "This is an important message.", confirmLabel: o = "Got it", onConfirm: s, rootProps: c, variant: l = "info", icon: u, loading: d = !1 }) => {
	let { isLoading: _, failure: v, clearFailure: w, run: E } = k(s, !0), D = _ || d, O = u ?? (l === "success" ? /* @__PURE__ */ f("div", {
		className: "mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-success/10",
		children: /* @__PURE__ */ f(n, {
			name: "CheckCircle",
			className: "h-6 w-6 text-success-text"
		})
	}) : l === "danger" ? /* @__PURE__ */ f("div", {
		className: "mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-destructive/10",
		children: /* @__PURE__ */ f(n, {
			name: "XCircle",
			className: "h-6 w-6 text-destructive"
		})
	}) : l === "warning" ? /* @__PURE__ */ f("div", {
		className: "mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-warning/10",
		children: /* @__PURE__ */ f(n, {
			name: "AlertTriangle",
			className: "h-6 w-6 text-warning-text"
		})
	}) : /* @__PURE__ */ f("div", {
		className: "mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-info/10",
		children: /* @__PURE__ */ f(n, {
			name: "Info",
			className: "h-6 w-6 text-info-text"
		})
	})), A = l === "danger" ? "danger" : l === "warning" ? "warning" : l === "success" ? "success" : "primary";
	return /* @__PURE__ */ p(g.Root, {
		lazyMount: !0,
		unmountOnExit: !0,
		closeOnInteractOutside: !1,
		...D ? { closeOnEscape: !1 } : null,
		...c,
		onOpenChange: (e) => {
			e.open || w(), c?.onOpenChange?.(e);
		},
		children: [/* @__PURE__ */ f(h, {
			condition: !!e,
			children: /* @__PURE__ */ f(g.Trigger, {
				asChild: !0,
				children: e
			})
		}), /* @__PURE__ */ p(m, { children: [/* @__PURE__ */ f(y, {}), /* @__PURE__ */ f(b, {
			centered: !0,
			children: /* @__PURE__ */ p(x, {
				size: "sm",
				children: [
					/* @__PURE__ */ p("div", {
						className: "text-center",
						children: [
							O,
							/* @__PURE__ */ f(S, {
								size: "md",
								className: "mt-4 text-center",
								children: i
							}),
							/* @__PURE__ */ f(C, {
								size: "md",
								className: "text-center",
								children: a
							})
						]
					}),
					v && /* @__PURE__ */ f("div", {
						className: "pt-3",
						children: /* @__PURE__ */ f(r, {
							config: {
								variant: "subtle",
								colorScheme: "danger"
							},
							description: v
						})
					}),
					/* @__PURE__ */ f(T, {
						align: "center",
						className: "mt-5 pt-0 border-0",
						children: /* @__PURE__ */ f(g.Context, { children: (e) => /* @__PURE__ */ f(t, {
							colorScheme: A,
							size: "sm",
							onClick: () => void E(() => e.setOpen(!1)),
							loading: D,
							disabled: D,
							className: "min-w-25",
							children: o
						}) })
					})
				]
			})
		})] })]
	});
}, M = ({ open: e, title: n, subtitle: i, onClose: a, onSubmit: o, submitLabel: s, submitScheme: c = "primary", submitDisabled: l = !1, busy: u = !1, error: d, cancelLabel: h = "Cancel", size: g = "md", children: v, extraActions: D }) => /* @__PURE__ */ f(_, {
	open: e,
	onOpenChange: (e) => {
		e.open || a();
	},
	lazyMount: !0,
	unmountOnExit: !0,
	children: /* @__PURE__ */ p(m, { children: [/* @__PURE__ */ f(y, {}), /* @__PURE__ */ f(b, {
		centered: !0,
		scrollMode: "inside",
		children: /* @__PURE__ */ p(x, {
			size: g,
			scrollMode: "inside",
			children: [/* @__PURE__ */ p("form", {
				onSubmit: (e) => {
					e.preventDefault(), e.stopPropagation(), o?.();
				},
				noValidate: !0,
				className: "flex min-h-0 flex-1 flex-col",
				children: [
					/* @__PURE__ */ p("div", {
						className: "pr-8",
						children: [/* @__PURE__ */ f(S, {
							size: "sm",
							children: n
						}), i !== void 0 && /* @__PURE__ */ f(C, {
							size: "sm",
							children: i
						})]
					}),
					/* @__PURE__ */ f(E, {
						className: "-mx-1 flex min-h-0 flex-1 flex-col gap-3 overflow-y-auto px-1 pb-1",
						children: v
					}),
					d && /* @__PURE__ */ f("div", {
						className: "pt-3",
						children: /* @__PURE__ */ f(r, {
							config: {
								variant: "subtle",
								colorScheme: "danger"
							},
							description: d
						})
					}),
					/* @__PURE__ */ p(T, {
						className: "pt-4",
						children: [
							D,
							/* @__PURE__ */ f(t, {
								variant: "outline",
								colorScheme: "default",
								onClick: a,
								children: h
							}),
							s && /* @__PURE__ */ f(t, {
								type: "submit",
								colorScheme: c,
								loading: u,
								disabled: l || u,
								children: s
							})
						]
					})
				]
			}), /* @__PURE__ */ f(w, {})]
		})
	})] })
}), N = ({ open: e, title: n, subtitle: r, onClose: i, closeLabel: a = "Close", size: o = "2xl", children: s, extraActions: c }) => /* @__PURE__ */ f(_, {
	open: e,
	onOpenChange: (e) => {
		e.open || i();
	},
	lazyMount: !0,
	unmountOnExit: !0,
	children: /* @__PURE__ */ p(m, { children: [/* @__PURE__ */ f(y, {}), /* @__PURE__ */ f(b, {
		centered: !0,
		scrollMode: "inside",
		children: /* @__PURE__ */ p(x, {
			size: o,
			scrollMode: "inside",
			children: [
				/* @__PURE__ */ p("div", {
					className: "pr-8",
					children: [/* @__PURE__ */ f(S, {
						size: "sm",
						children: n
					}), r !== void 0 && /* @__PURE__ */ f(C, {
						size: "sm",
						children: r
					})]
				}),
				/* @__PURE__ */ f(E, {
					className: "-mx-1 flex min-h-0 flex-1 flex-col gap-3 overflow-y-auto px-1 pb-1",
					children: s
				}),
				/* @__PURE__ */ p(T, {
					className: "pt-4",
					children: [c, /* @__PURE__ */ f(t, {
						variant: "outline",
						colorScheme: "default",
						onClick: i,
						children: a
					})]
				}),
				/* @__PURE__ */ f(w, {})
			]
		})
	})] })
}), P = () => null;
P.Default = D, P.Form = M, P.View = N, P.Confirmation = A, P.Alert = j, P.Root = _, P.Trigger = v, P.Backdrop = y, P.Positioner = b, P.Content = x, P.Title = S, P.Description = C, P.CloseTrigger = w, P.Body = E, P.Footer = T, P.Portal = m, P.Context = g.Context;
export { P as Modal };

//# sourceMappingURL=index.js.map